import Icon from '../components/Icon.vue'

Icon.register({
  'th-list': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M149.3 216v80c0 13.3-10.7 24-24 24h-101.3c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24h101.3c13.3 0 24 10.7 24 24zM0 376c0-13.3 10.7-24 24-24h101.3c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-101.3c-13.3 0-24-10.7-24-24v-80zM125.3 32c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-101.3c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24h101.3zM205.3 480c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24h282.7c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-282.7zM181.3 56c0-13.3 10.7-24 24-24h282.7c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-282.7c-13.3 0-24-10.7-24-24v-80zM205.3 320c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24h282.7c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-282.7z'
      }
    ]
  }
})
